__turbopack_context__.v({
  "channels": "Contact-module-scss-module__xmkSba__channels",
  "container": "Contact-module-scss-module__xmkSba__container",
});
